import { isReservedHost } from './origins.mjs';

/**
 * Whether an address is one we could ever actually reach.
 *
 * The contact form hands the address to a person who will reply to it. An
 * address on a reserved domain makes that impossible: RFC 2606 and RFC 6761
 * set these names aside precisely so they can never be delivered to. Catching
 * it at the form is the only point where we can still say so to the person
 * typing, instead of discovering it as a bounce.
 */

/**
 * True when the address is on a domain reserved to be undeliverable.
 *
 * Assumes the address has already passed a syntax check (`z.email()` in the
 * contact schema), so this only has to answer the reserved-domain question.
 */
export function isReservedEmailDomain(address: string): boolean {
  const at = address.lastIndexOf('@');
  if (at < 0) return false;
  // The same special-use list as configured origins and contact addresses
  // (.test, .example, .invalid, .localhost, .local, .onion, .internal, .alt,
  // example.com/.net/.org, home.arpa, IP literals, single-label names).
  return isReservedHost(address.slice(at + 1).trim());
}
